import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpUtil } from '../lib/core';
import { HeadersService, ConfigService } from '../lib/service';

import 'rxjs/Rx';
import { Observable }     from 'rxjs/Observable';

import { Pesquisa } from '../lib/model'
import { GeoCode } from './geocode';

@Injectable()
export class PesquisaService {

    constructor(private _http: Http, private _headerService: HeadersService) { }


    public getGeoLocation(id_endereco: number): Observable<any>
    {
        let url = ConfigService.URLAPI;

        return this._http
            .get(url + '/site/dentistas/buscargeolocation/' + id_endereco, this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)
    }


    public getFiltrosBasicos(registroANS: string, pesquisa: Pesquisa): Observable<any[]>
    {
        const url = ConfigService.URLAPI;

        const data = {
            registroANS: registroANS,
            isRedeNacional: pesquisa.isRedeNacional
        }

        return this._http
            .post(url + '/site/dentistas/filtros', JSON.stringify(data), this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)
    }

    public getFiltrosCidades(registroANS: string, pesquisa: Pesquisa): Observable<any[]>
    {
        const url = ConfigService.URLAPI;

        const data = {
            registroANS: registroANS,
            isRedeNacional: pesquisa.isRedeNacional,
            uf: pesquisa.uf
        };

        return this._http
            .post(url + '/site/dentistas/filtros/cidades', JSON.stringify(data), this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)
    }

    public getFiltrosBairros(registroANS: string, pesquisa: Pesquisa): Observable<any[]>
    {
        const url = ConfigService.URLAPI;

        const data = {
            registroANS: registroANS,
            isRedeNacional: pesquisa.isRedeNacional,
            cidade: pesquisa.cidade
        };

        return this._http
            .post(url + '/site/dentistas/filtros/bairros', JSON.stringify(data), this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)            
    }

    public pesquisar(skip: number, take: number, pesquisa: Pesquisa, registroANS: string): Observable<any[]>
    {        
        //alert(JSON.stringify(pesquisa));
        let url = ConfigService.URLAPI;

        pesquisa.skip = skip;
        pesquisa.take = take;
        pesquisa.registroANS = registroANS;

        return this._http
            .post(url + '/site/dentistas/consulta', JSON.stringify(pesquisa), this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)      
    }

    public getNomeUniodonto(registroANS: string): Observable<any>
    {        
        let url = ConfigService.URLAPI;

        return this._http
            .get(url + '/site/dentistas/uniodonto/' + registroANS, this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)      
    }  

    public getDadosUniodonto(registroANS: string): Observable<any>
    {        
        let url = ConfigService.URLAPI;

        return this._http
            .get(url + '/site/dentistas/uniodonto/' + registroANS + '/dados', this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError)      
    } 

    public imprimir(pesquisa: Pesquisa)
    {
        let url = ConfigService.URLAPI;

        return this._http
            .post(url + '/site/dentistas/imprimir', JSON.stringify(pesquisa), this._headerService.getJsonHeaders())
            .map(HttpUtil.extractData)
            .catch(HttpUtil.handleError);
    }  
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/pesquisa.service.ts
 **/